const openRoom = (params) => {
  const paramsArr = Object.entries(params).filter(([, v]) => v !== void 0 && v !== null).map(([k, v]) => `${k}=${v}`);
  return `hiya://openRoom?${paramsArr.join("&")}`;
};
const openUser = (params) => {
  return `hiya://openUser?uid=${params.uid}&tab=${params.tab}`;
};
const openChat = (params) => {
  const paramsArr = Object.entries(params).filter(([, v]) => v !== void 0 && v !== null).map(([k, v]) => `${k}=${v}`);
  return `hiya://openChat?${paramsArr.join("&")}`;
};
const openMedal = () => {
  return "hiya://openMedal";
};
const openSetting = () => {
  return "hiya://openSetting";
};
const openCreateRoom = () => {
  return "hiya://openCreateRoom";
};
const openEnrichImpression = () => {
  return "hiya://openEnrichImpression";
};
const openCreatePost = (params) => {
  return `hiya://createPost?from=${params.from}&simple_topic_name=${encodeURIComponent(
    params.simple_topic_name
  )}`;
};
const openNotifications = () => {
  return "hiya://openNotifications";
};
const openPostDetail = (params) => {
  const paramsArr = Object.entries(params).filter(([, v]) => v !== void 0 && v !== null).map(([k, v]) => `${k}=${v}`);
  return `hiya://openPostDetail?from=web&${paramsArr.join("&")}`;
};
const openFamily = (params) => {
  return `hiya://openFamily?from=web&fid=${params.fid}`;
};
const openFamilyList = () => {
  return "hiya://openFamilyList?from=web";
};
const openFamilyMemberList = (params) => {
  return `hiya://openFamilyMemberList?from=web&fid=${params.fid}`;
};
const openCreateFamily = () => {
  return "hiya://openCreateFamily";
};
const openGroupChat = (params) => {
  return `hiya://openGroupChat?group_id=${params.group_id}&operationtType=0`;
};
const openStore = (params) => {
  return `hiya://openStore?tab=${params.tab}`;
};
const openHomeTab = () => {
  return "hiya://openHomeTab";
};
const openLudoTabAndMatch = (params) => {
  return `hiya://openLudoTabAndMatch?from=${params.from}`;
};
const openFunnyGame = (index = 0) => {
  return `hiya://openFunnyGame?index=${index}`;
};
const openGameQuickMatch = (params) => {
  const paramsArr = Object.entries(params).filter(([, v]) => v !== void 0 && v !== null).map(([k, v]) => `${k}=${v}`);
  return `hiya://openGameQuickMatch?from=chat&${paramsArr.join("&")}&game_tag=ludo`;
};
const openTopic = (params) => {
  return `hiya://openTopic?tid=${params.tid}`;
};
const openFamilyMission = (params) => {
  return `hiya://openFamilyMission?family_id=${params.family_id}`;
};
const openFamilyInvite = (params) => {
  const paramsArr = Object.entries(params).filter(([, v]) => v !== void 0 && v !== null).map(([k, v]) => `${k}=${v}`);
  return `hiya://openFamilyInvite?${paramsArr.join("&")}`;
};
const openMainTab = (params) => {
  return `hiya://openMainTab?tab=${params.tab}`;
};
const jumpWeeklyCard = () => {
  return "hiya://jumpWeeklyCard";
};
export {
  jumpWeeklyCard,
  openChat,
  openCreateFamily,
  openCreatePost,
  openCreateRoom,
  openEnrichImpression,
  openFamily,
  openFamilyInvite,
  openFamilyList,
  openFamilyMemberList,
  openFamilyMission,
  openFunnyGame,
  openGameQuickMatch,
  openGroupChat,
  openHomeTab,
  openLudoTabAndMatch,
  openMainTab,
  openMedal,
  openNotifications,
  openPostDetail,
  openRoom,
  openSetting,
  openStore,
  openTopic,
  openUser
};
